import styled from 'styled-components';
import media from 'styled-media-query';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  background: #FEFEFE;
  padding: 32px;
  border-radius: 8px;
  width: 90%;
  max-width: 718px;
  box-shadow: 0px 12px 12px 0px rgba(22, 22, 22, 0.04), 0px 24px 56px 0px rgba(22, 22, 22, 0.08);

  ${media.greaterThan('large')`
    width: 718px;
  `}
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-direction: column;
  gap: 16px;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  color: #A95B3D;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: rgba(22, 22, 22, 0.88);
  align-self: flex-end;
`;

export const Content = styled.div`
  padding-bottom: 24px;
`;
